import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  Permission,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'
import { getAvaliacoes, getAvaliacoesByResponsavel } from './_requests'
import { FormularioAtendimentoList } from '../../avaliacoes-pendentes-list/core/_models'
import { useModal } from '../../../../../components'
import { useAuth } from '../../../../auth'
import { isVinculoMedico } from 'app/modules/auth/core/vinculos'

const QueryResponseContext = createResponseContext<FormularioAtendimentoList>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()
  const { currentUser } = useAuth()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const isAdmin =
    currentUser?.grupo?.nome === Permission.SuperAdmin ||
    currentUser?.grupo?.nome === Permission.SuperMedico ||
    currentUser?.grupo?.nome === Permission.Admin

  const isMedico = currentUser?.vinculos?.some(
    (vinculo) => vinculo.funcionario && isVinculoMedico(vinculo)
  )

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.AVALIACOES_LIST, query, isOpen],
    () => (isAdmin || !isMedico ? getAvaliacoes(query) : getAvaliacoesByResponsavel(query)),
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !isOpen,
    }
  )

  return (
    <QueryResponseContext.Provider
      value={{
        isLoading: isFetching,
        isError,
        refetch,
        response,
        query,
      }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
